import authModalLoader from '../auth/authModalLoader';

const triggerAuthModal = ({ action, flow }) => (options = {}) => {
    const { email, label } = options;

    return authModalLoader.show({
        action,
        flow,
        email,
        ga: {
            label
        }
    });
};

export const authModalFlows = authModalLoader.constants;
export const basicLogin = triggerAuthModal({ action: authModalFlows.LOGIN, flow: authModalFlows.LOGIN });
export const consumerAltRegistration = triggerAuthModal({ action: authModalFlows.REGISTER, flow: authModalFlows.ALT_REGISTRATION_CONSUMER_FLOW });
export const tradeAltRegistration = triggerAuthModal({ action: authModalFlows.REGISTER, flow: authModalFlows.ALT_REGISTRATION_TRADE_FLOW });
export const tradeAppLogin = triggerAuthModal({ action: authModalFlows.LOGIN, flow: authModalFlows.TRADE_APPLICATION_FLOW });
export const tradeAppRegistration = triggerAuthModal({ action: authModalFlows.REGISTER, flow: authModalFlows.TRADE_APPLICATION_FLOW });



// WEBPACK FOOTER //
// ./assets/js/postAuth/authInterface.es.js